import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SidebarComponent } from '../components/main/sidebar/sidebar.component';
import { NavbarComponent } from '../components/main/navbar/navbar.component';
import { MenuService } from '@/app/services/common/menu.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent, NavbarComponent, NgOptimizedImage],
  templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent {
  private menuService = inject(MenuService);

  contentMargin = computed(() => {
    const isExpanded = this.menuService.isSidebarExpanded();
    return isExpanded ? 'md:ml-[284px]' : 'md:ml-[80px]';
  });
}
